// extracted by mini-css-extract-plugin
export default {"c-editor":"Editor_c-editor__jyJiE","c-editor__ace":"Editor_c-editor__ace__eNXVJ"};